export default __webpack_public_path__ + "static/media/19.c70ba90a.jpg";